
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apipages/legacy-libraries",
      function () {
        return require("private-next-pages/apipages/legacy-libraries/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apipages/legacy-libraries"])
      });
    }
  